<template>
  <Modal
    v-model="shareModal"
    title="分享"
    draggable
    width="1000"
    @on-cancel="closeModal"
    scrollable
    :mask="false"
  >
    <Row type="flex" justify="space-between" class-name="wrap">
      <Col span="7">
        <Input
          v-model="searchForm.username"
          search
          placeholder="请输入用户名搜索"
          @on-search="getUserList"
        />
        <Tree
          ref="tree"
          title="true"
          :data="data"
          :load-data="loadData"
          @on-check-change="changeSelect"
          @on-select-change="selectTree"
          :check-strictly="!strict"
        ></Tree>
      </Col>
      <Col span="13">
        <Table
          :columns="userColumns"
          :data="userData"
          border
          ref="selection"
          @on-selection-change="selectTableChange"
        ></Table>
      </Col>
      <Col span="4">
        <List>
          <ListItem v-for="it in selectUserList" :key="it.id"
            ><span>{{ it.username }}</span>
            <template slot="extra">
              <Icon type="ios-close-circle-outline" @click="delSelectUserList(it.id)" />
            </template>
          </ListItem>
        </List>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="closeModal">取消</Button>
      <Button type="primary" @click="handleClickShare()">分享</Button>
    </div>
  </Modal>
</template>
<script>
import {
  initDepartment,
  loadDepartment,
  searchDepartment,
  getUserByDepartmentId,
  shareMylaryer,
  searchUserByName,
} from '@/api/index';
export default {
  name: 'share-modal',
  data() {
    return {
      shareModal: false,
      userData: [],
      userColumns: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
        },
        {
          type: 'index',
          width: 80,
          align: 'center',
          title: '序号',
        },
        {
          title: '用户名',
          key: 'username',
          align: 'center',
        },
        {
          title: '邮箱',
          key: 'email',
          align: 'center',
        },
        {
          title: '电话号码',
          key: 'mobile',
          align: 'center',
        },
      ],
      contextData: {},
      selectUserList: [],
      selectUserListMap: null,
      searchForm: {
        username: '',
      },
      loading: true,
      strict: true,
      userLoading: false,
      loadingEdit: true,
      modalVisible: false,
      selectList: [],
      selectCount: 0,
      showParent: false,
      modalTitle: '',
      editTitle: '',
      searchKey: '',
      submitLoading: false,
      data: [],
      dataEdit: [],
      users: [],
    };
  },
  methods: {
    init() {
      this.getParentList();
      this.getParentListEdit();
    },
    handleClickShare() {
      let id = this.contextData.id;
      let createBy = '';
      if (this.selectUserList.length == 0) {
        return this.$Message.info('请选择分享用户');
      }
      this.selectUserList.forEach((it, i) => {
        if (i >= 1) {
          createBy += ',';
        }
        createBy += `${it.id}@${it.username}`;
      });
      let params = {
        id,
        createBy,
      };
      shareMylaryer(params).then(res => {
        if (!res.success) {
          return this.$Message.warning(res.message);
        }
        this.$Message.success('分享成功');
        this.shareModal = false;
        // 重置
        this.resetModal();
      });
    },
    selectTableChange(newdata) {
      // this.selectShareData = newdata;
      let arr = this.selectUserList;

      // push数据
      newdata.forEach(it => {
        arr.push(it);
        this.selectUserListMap.set(it.id, it.id);
      });

      // 去重
      let obj = {};
      this.selectUserList = arr.reduce((cur, next) => {
        obj[next.id] ? '' : (obj[next.id] = true && cur.push(next));
        return cur;
      }, []);
      // 取消选中数据筛选
      if (Array.isArray(this.userData) && Array.isArray(newdata) && this.selectUserList) {
        this.userData.forEach(it => {
          const id = it.id;
          let f = true;
          newdata.forEach(item => {
            if (id == item.id) {
              f = false;
            }
          });
          if (f) {
            if (!this.selectUserListMap.has(id)) {
              return;
            } else {
              this.selectUserListMap.delete(id);
              this.selectUserList = this.selectUserList.filter(_item => {
                return _item.id != id;
              });
            }
          }
        });
      }

      this.setSelectUser();
    },
    showModal(contextData) {
      if (!contextData.id) {
        this.$Message.warning('图层id不存在，分享失败');
      }
      this.shareModal = true;
      this.contextData = contextData;
    },
    closeModal() {
      this.shareModal = false;
      this.resetModal();
    },
    resetModal() {
      this.$refs.selection.selectAll(false);
      this.selectUserList = [];
      this.selectUserListMap = new Map();
    },
    delSelectUserList(id) {
      this.selectUserList = this.selectUserList.filter(it => {
        return it.id !== id;
      });
      this.selectUserListMap.delete(id);
      this.setSelectUser();
    },
    setSelectUser() {
      this.userData = this.userData.map(it => {
        this.selectUserListMap.has(it.id) ? (it._checked = true) : (it._checked = false);
        return it;
      });
    },
    getUserList() {
      searchUserByName(this.searchForm.username).then(res => {
        if (res.success === true) {
          this.userData = res.result;
          this.setSelectUser();
        }
      });
    },
    //-------------------------------------
    getParentList() {
      this.loading = true;
      initDepartment().then(res => {
        this.loading = false;
        if (res.success === true) {
          res.result.forEach(function(e) {
            if (e.isParent) {
              e.loading = false;
              e.children = [];
            }
          });
          this.data = res.result;
        }
      });
    },
    getParentListEdit() {
      this.loadingEdit = true;
      initDepartment().then(res => {
        this.loadingEdit = false;
        if (res.success === true) {
          res.result.forEach(function(e) {
            if (e.isParent) {
              e.loading = false;
              e.children = [];
            }
          });
          // 头部加入一级
          let first = {
            id: '0',
            title: '一级部门',
          };
          res.result.unshift(first);
          this.dataEdit = res.result;
        }
      });
    },
    loadData(item, callback) {
      loadDepartment(item.id).then(res => {
        if (res.success === true) {
          res.result.forEach(function(e) {
            if (e.isParent) {
              e.loading = false;
              e.children = [];
            }
          });
          callback(res.result);
        }
      });
    },
    search() {
      if (this.searchKey) {
        this.loading = true;
        searchDepartment({ title: this.searchKey }).then(res => {
          this.loading = false;
          if (res.success) {
            this.data = res.result;
          }
        });
      } else {
        this.getParentList();
      }
    },
    selectTree(v) {
      if (v.length > 0) {
        // 转换null为""
        for (let attr in v[0]) {
          if (v[0][attr] === null) {
            v[0][attr] = '';
          }
        }
        let str = JSON.stringify(v[0]);
        let data = JSON.parse(str);
        this.editTitle = data.title;
        // 加载部门用户数据
        this.userLoading = true;
        getUserByDepartmentId(data.id).then(res => {
          this.userLoading = false;
          if (res.success) {
            this.userData = res.result;
            this.setSelectUser();
          }
        });
        // 回显
        this.form = data;
      } else {
        this.cancelEdit();
      }
    },
    cancelEdit() {
      let data = this.$refs.tree.getSelectedNodes()[0];
      if (data) {
        data.selected = false;
      }
      this.$refs.form.resetFields();
      delete this.form.id;
      this.editTitle = '';
    },
    selectTreeEdit(v) {
      if (v.length > 0) {
        // 转换null为""
        for (let attr in v[0]) {
          if (v[0][attr] === null) {
            v[0][attr] = '';
          }
        }
        let str = JSON.stringify(v[0]);
        let data = JSON.parse(str);
        this.form.parentId = data.id;
        this.form.parentTitle = data.title;
      }
    },
    cancelAdd() {
      this.modalVisible = false;
    },
    handleReset() {
      this.$refs.form.resetFields();
      this.form.status = 0;
    },
    changeSelect(v) {
      this.selectCount = v.length;
      this.selectList = v;
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.selectUserListMap = new Map();
  },
};
</script>

<style lang="less" scoped>
.wrap {
  height: 100%;
}
.ivu-list-item {
  display: flex;
  justify-content: space-between;
}
/deep/ .ivu-col {
  padding: 0 2px;
}
/deep/ .ivu-col-span-7 {
  border-right: 1px solid #eee;
}
/deep/ .ivu-col-span-4 {
  border-left: 1px solid #eee;
  padding-left: 20px;
}
/deep/ .ivu-modal-body {
  height: 60vh;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/layers/shareModal.vue